var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandServiceC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .icon-service-1 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-5);\r\n      }\r\n\r\n      .icon-service-2 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1);\r\n      }\r\n\r\n      .icon-service-3 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-3);\r\n      }\r\n\r\n      .icon-service-4 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-4);\r\n      }\r\n\r\n      .icon-service-5 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 98.87,
    y1: 97.46,
    x2: 25.63,
    y2: 24.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f89cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3f9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-2",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 118.16,
    y1: 78.17,
    x2: 44.91,
    y2: 4.92,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-3",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 83.34,
    y1: 112.99,
    x2: 10.1,
    y2: 39.74,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-4",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 98.44,
    y1: 97.88,
    x2: 25.2,
    y2: 24.64,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-5",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 98.16,
    y1: 98.16,
    x2: 24.92,
    y2: 24.92,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-service-2",
    d: "m51.99,43.3v4.52h-29.75v-4.52h9.94v-11.06h5.67v11.06h14.14Zm-9.49-3.68c1.19-5.95,1.33-10.4,1.33-14.07h-18.62v-4.45h24.29v3.08c0,4.1,0,8.82-1.36,16.03l-5.64-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-service-5",
    d: "m68.62,20.82c0,8.51-3.57,13.86-12.25,17.08l-2.59-4.1c5.78-2,8.33-4.76,9-8.58h-7.28v-4.41h13.13Zm-9.21,18.17h23.17v12.46h-5.67v-8.02h-17.5v-4.45Zm23.17-20.41v19.15h-5.36v-7.42h-1.92v7.39h-5.25v-18.48h5.25v6.62h1.92v-7.25h5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-service-3",
    d: "m35.44,61.84c0,5.18,1.93,10.82,7.77,13.23l-3.05,4.41c-3.68-1.5-6.09-4.38-7.53-7.95-1.4,3.96-3.82,7.14-7.63,8.82l-3.19-4.48c5.92-2.55,7.88-8.58,7.88-14.04v-.6h-6.44v-4.62h18.48v4.62h-6.3v.6Zm14.25-8.23v32.8h-5.67v-32.8h5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-service-4",
    d: "m83.18,81.52v4.45h-24.99v-9.87h4.38v-4.06c-2.66.14-5.25.18-7.56.18l-.67-4.41c5.95-.04,13.86-.1,20.69-1.02l.39,3.99c-2.38.42-4.83.7-7.25.91v6.06h-4.38v3.78h19.39Zm-26.6-21c0-3.47,3.43-5.92,8.23-5.92s8.26,2.45,8.26,5.92-3.43,5.95-8.26,5.95-8.23-2.42-8.23-5.95Zm5.36,0c0,1.29,1.19,1.85,2.87,1.85s2.91-.56,2.91-1.85-1.15-1.82-2.91-1.82-2.87.56-2.87,1.82Zm14.88,11.97v-18.9h5.67v24.85h-5.67v-2.14h-5.88v-3.82h5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-service-1",
    d: "m97.5,105H7.5c-4.14,0-7.5-3.36-7.5-7.5V7.5C0,3.36,3.36,0,7.5,0h90c4.14,0,7.5,3.36,7.5,7.5v90c0,4.14-3.36,7.5-7.5,7.5ZM7.5,5c-1.38,0-2.5,1.12-2.5,2.5v90c0,1.38,1.12,2.5,2.5,2.5h90c1.38,0,2.5-1.12,2.5-2.5V7.5c0-1.38-1.12-2.5-2.5-2.5H7.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandServiceC);
export default __webpack_public_path__ + "static/media/brand-service-c.b84501104641a09bebd4c9a0f8cfcd49.svg";
export { ForwardRef as ReactComponent };